import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { CommesseApi } from "../data/apis";
import { useMemo } from "react";

export function useCommessaDataSource(personaleId: number, data: Date | null, clienteId: number | null) {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new CommesseApi(apiConfiguration);

        return new CustomStore({
            key: 'idCommessa',
            loadMode: 'raw',
            load: (loadOptions) => {
                return api.getCommesse({
                    idPersonale: personaleId,
                    data: data,
                    idCliente: clienteId
                });
            }
        })
    }, [personaleId, data, clienteId, apiConfiguration]);

    return dataSource;
}